// import Vue from "vue";
// import App from "./App.vue";
// import vuetify from "./plugins/vuetify";
// import router from "./router";
// import Toasted from "vue-toasted";
// import store from "@/store";
// import moment from "moment";
// import "./scss/main.scss";
// import "./plugins/apexChart";

// Vue.config.productionTip = false;
// Vue.use(Toasted);
// Vue.prototype.moment = moment;

// Vue.prototype.$canRoute = function (routePath) {
//   const user = this.$store.state.admins.loggedAdmin;

//   if (!user) return false;
//   if (user.is_dev === 1) return 1;

//   const sub = user.subModules.find(s => s.route === routePath);
//   if (!sub) return false;
//   return user.permissions[sub.id];
// };



// if (process.env.VUE_APP_NODE_ENV === 'production') {
//   Vue.config.devtools = false;
//   Vue.config.debug = false;
//   Vue.config.silent = true;
// }

// new Vue({
//   store,
//   vuetify,
//   router,
//   render: (h) => h(App),
// }).$mount("#app");


import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import Toasted from "vue-toasted";
import store from "@/store";
import moment from "moment";
import axios from "axios";
import "./scss/main.scss";
import "./plugins/apexChart";

Vue.config.productionTip = false;
Vue.use(Toasted);
Vue.prototype.moment = moment;

/* -----------------------------------------------
   Permission Helper (already exists)
------------------------------------------------ */
Vue.prototype.$canRoute = function (routePath) {
  const user = this.$store.state.admins.loggedAdmin;

  if (!user) return false;
  if (user.is_dev === 1) return 1;

  const sub = user.subModules.find(s => s.route === routePath);
  if (!sub) return false;
  return user.permissions[sub.id];
};

axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 403) {
      window.location.href = "/403";  // redirect to dashboard
    }
    return Promise.reject(err);
  }
);


/* -----------------------------------------------
   OPTIONAL: Also add request interceptor
   Sends browser page route to backend
------------------------------------------------ */
axios.interceptors.request.use(config => {
  const currentRoute = window.location.pathname.replace("/", "");

  config.headers["x-page-route"] = currentRoute || "403";
  return config;
});


/* ----------------------------------------------- */
if (process.env.VUE_APP_NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

/* ----------------------------------------------- */
new Vue({
  store,
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");

